import { useContext } from 'react';
import { TourContext } from '.';

export function useTourContext() {
  return useContext(TourContext);
}
